import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=647727ba&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647727ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('647727ba')) {
      api.createRecord('647727ba', component.options)
    } else {
      api.reload('647727ba', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=647727ba&scoped=true&", function () {
      api.rerender('647727ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2IBCuvEpl5HYn/JS/comp/Accordion.vue"
export default component.exports